// libraries
import React, { Fragment, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Redirect } from "react-router-dom"
import {get, startCase, lowerCase, sortBy, get as _get} from "lodash";

// store and utils
import {DateTime} from "luxon";
import validators from "../../../utils/forms/validators";
import formatters from "../../../utils/forms/formatters";

// components
import FileUploadInput from "../../theme/forms/FileUploader";
import FormModal from "../../theme/modals/FormModal";
import {getUUID} from "../../../utils/hashFuncs";
import AlertCard from "../../theme/cards/AlertCard";
import ProjectCard from "../../subcomponents/dashboard/ProjectCard";




function AddFileModal(props) {
    return (
        <FormModal
            inputs={[
                {
                    type: "text",
                    dataKey: "name",
                    label: "Name your file *",
                    inputClasses: "is-medium",
                    ...validators.isStringOfMinLength(2),
                },
            ]}
            title="Add a file"
            onSubmit={props.onSubmit}
            onCancel={props.onCancel}
            visible={props.visible}
        />
    )
}

function FileUploadPrompt(props) {

    const [inputs, setInputs] = useState(props.inputs || [])
    const [showAddFileModal, setShowAddFileModal] = useState(false);


    const getFileUploaders = () => {
         return (
             <div className="box form-container-box">
                     {inputs.map(d => (
                         <FileUploadInput
                             inputClasses="is-medium"
                             {...d}
                             userFileData={{application_id: props.application_id}}
                             key={d.dataKey}
                         />
                     ))}
                 </div>
         )
    }

    const handleFileAddition = (formVals) => {
         let {name} = formVals;
         setInputs([...inputs, {label: name, description: name, dataKey: getUUID()}])
        setShowAddFileModal(false);
    }

    return (
        <div>
            <div className="box">
                <div className="level">
                    <div className="level-left">
                        <div className="level-item">
                            <p className="mr-6 my-0">Files marked with a * are required. You may add as many other files as needed.</p>
                        </div>
                    </div>
                    <div className="level-right">
                        <div className="level-item">
                            <div
                                className="button is-medium  is-link"
                                onClick={() => setShowAddFileModal(true)}
                            >
                                + Add Another File
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {!!inputs.length && getFileUploaders()}
            <AddFileModal
                visible={showAddFileModal}
                onCancel={() => setShowAddFileModal(false)}
                onSubmit={handleFileAddition}
            />
        </div>
    )
}


function ApplicationFileUpload() {
    let appData = useSelector(state => state.applicationData)
    let existing_files = (appData?.app?.files || [])
        .sort((a,b) => DateTime.fromISO(a.created) > DateTime.fromISO(b.created) ? -1 : 1)
    let required_files = (appData?.app?.template?.elements || []).filter(d => d.type === 'file')
    const getFileElements = ()  => {
        let elements = []
        required_files.forEach(d => {
            let matching_upload = existing_files.find(ex => ex.datakey === d.id) || {}
            elements.push({
                label: `${d.name} *`,
                description: d.name,
                dataKey: d.id,
                link: matching_upload.link,
                placeholder: (
                    matching_upload.created ?
                    `Uploaded on ${formatters.date().formatter(matching_upload.created)}` :
                    null
                ),
                subLabel: (
                    matching_upload.link ?
                    <a href={matching_upload.link} target="_blank" rel="noreferrer">View uploaded file</a> :
                    null
                )
            })
        })

        let matched_ids = elements.map(d => d.dataKey)
        let remaining_files = existing_files.filter(d => !matched_ids.includes(d.datakey))

        remaining_files.forEach(d => {
            elements.push({
                label: d.description,
                dataKey: d.datakey,
                link: d.link,
                placeholder: (
                    d.created ?
                        `Uploaded on ${formatters.date().formatter(d.created)}` :
                        null
                ),
                subLabel: (
                    d.link ?
                        <a href={d.link} target="_blank" rel="noreferrer">View uploaded file</a> :
                        null
                )
            })
        })
        return elements;
    }


    return (<div>
            <FileUploadPrompt
                inputs={getFileElements()}
                application_id={appData.app.id}
            />
        </div>
    );

}


export default ApplicationFileUpload;
